
import CouponItem from '~/pages/_lang/coupon-item/_id.vue'
export default CouponItem
